import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-46cba2cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "project-detail-top"
};
const _hoisted_2 = {
  class: "project-detail-top-left"
};
const _hoisted_3 = {
  class: "images"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "project-detail-top-right"
};
const _hoisted_6 = {
  class: "tag-box"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "horizontal-line"
}, null, -1));
const _hoisted_8 = {
  class: "video_link"
};
const _hoisted_9 = {
  class: "project_type"
};
const _hoisted_10 = {
  class: "package_price"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "550"
  }
}, "项目价格：", -1));
const _hoisted_12 = {
  style: {
    "font-weight": "550",
    "color": "red"
  }
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "20px"
  }
}, "￥", -1));
const _hoisted_14 = {
  style: {
    "font-size": "30px"
  }
};
const _hoisted_15 = {
  class: "buy_button",
  style: {
    "text-align": "center"
  }
};
const _hoisted_16 = {
  class: "agreement-wrapper"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "14px"
  }
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/agreement/userAgreement.html",
  target: "_blank"
}, "用户协议 "), /*#__PURE__*/_createTextVNode(" 、 "), /*#__PURE__*/_createElementVNode("a", {
  href: "/agreement/payAgreement.html",
  target: "_blank"
}, "购买协议 "), /*#__PURE__*/_createTextVNode(" 和 "), /*#__PURE__*/_createElementVNode("a", {
  href: "/agreement/privacyAgreement.html",
  target: "_blank"
}, " 隐私政策")], -1));
import { onMounted, ref, watch } from 'vue';
import { ClockCircleOutlined, EyeOutlined, ShoppingCartOutlined } from '@ant-design/icons-vue';
import dayjs from "dayjs";
import { XiaoniuFrontedControllerService } from "../../../../generated/services/XiaoniuFrontedControllerService";
import { message } from "ant-design-vue";
import { useLoginUserStore } from "@/store/loginUser";
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseDesignDetailTop',
  props: {
    projectDetail: {},
    dictList: {},
    homeworkViewCount: {},
    homeworkBuyCount: {}
  },
  setup(__props) {
    const buyButtonText = ref('正在为您火速下单中...3秒');
    const dialogVisibleRedeem = ref(false);
    const packageType = ref("0");
    const agreementChecked = ref(false);
    const formattedCreateDate = ref('');
    const links = ref([]);
    const priceList = ref([]);
    const packagePrice = ref(null);
    const isClickBuy = ref(false);
    const loginUserStore = useLoginUserStore();
    const projectType = ref('');
    const props = __props;
    const cdk = ref('');
    const getImageUrl = item => {
      return item.imageUrl === null || item.imageUrl === '' ? require("@/assets/default-project-detail-in.png") : item.imageUrl;
    };
    //确认兑换
    const handleOk = () => {
      //校验兑换码是否有效
      //如果无效，提示错误信息
      // console.log(cdk.value);
      if (cdk.value === "") {
        message.error("请输入兑换码");
        return;
      }
      const courseOrder = {
        ...props.projectDetail,
        //课设订单为类型为4
        packageType: Number(4),
        cdk: cdk.value
      };
      XiaoniuFrontedControllerService.redeemUsingPost(courseOrder).then(res => {
        if (res.data.code === 200) {
          //如果有效，提示成功信息、创建订单
          message.success("兑换成功,请到我的订单界面查收~");
          dialogVisibleRedeem.value = false;
        } else {
          message.error(res.data.msg);
        }
      });
    };
    //取消兑换
    const handleCancel = () => {
      dialogVisibleRedeem.value = false;
      cdk.value = '';
    };
    const startCountdown = async () => {
      buyButtonText.value = `正在为您火速下单中...3秒`;
      if (isClickBuy.value) return; // 防止重复点击
      isClickBuy.value = true;
      let countdown = 3;
      const interval = setInterval(async () => {
        countdown -= 1;
        buyButtonText.value = `正在为您火速下单中...${countdown}秒`;
        if (countdown <= 0) {
          clearInterval(interval);
          const orderRes = await addOrder();
          if (orderRes.code === 200) {
            if (orderRes.data.num === "0") {
              //免费下载成功
              message.success("下单成功,请到我的订单界面查收~");
              isClickBuy.value = false;
            } else {
              //下单成功  跳转到支付页面
              //调用支付接口
              const payRes = await payOrder(orderRes.data.orderNo);
              //跳转到支付页面
              window.location = payRes.paymentUrl;
            }
          } else {
            //下单失败  清除定时器 恢复按钮原始状态 提示错误信息
            message.error(orderRes.msg);
            isClickBuy.value = false;
          }
        }
      }, 1000);
    };
    const payOrder = async orderNo => {
      const res = await XiaoniuFrontedControllerService.payUsingPost(orderNo);
      return res;
    };
    const addOrder = async () => {
      //添加支付订单
      const courseOrder = {
        ...props.projectDetail,
        //课设订单为类型为4
        packageType: Number(4)
      };
      const res = await XiaoniuFrontedControllerService.addOrderCourse(courseOrder);
      return res;
    };
    //兑换
    const redeem = () => {
      //查询用户登陆状态
      if (!loginUserStore.isLogin) {
        message.error('您尚未登录~');
        return;
      }
      //检查是否勾选同意
      if (!agreementChecked.value) {
        message.error('未勾选同意协议~');
        return;
      }
      //弹出兑换窗口
      dialogVisibleRedeem.value = true;
    };
    //下单
    const buy = () => {
      //查询用户登陆状态
      if (!loginUserStore.isLogin) {
        message.error('您尚未登录~');
        return;
      }
      //检查是否勾选同意
      if (!agreementChecked.value) {
        message.error('未勾选同意协议~');
        return;
      }
      //设置定时器3秒  同时进行下单操作
      startCountdown();
    };
    const formattedHomeworkViewCount = ref('0');
    const formattedHomeworkBuyCount = ref('0');
    watch([() => props.projectDetail, () => props.dictList, () => props.homeworkBuyCount, () => props.homeworkViewCount],
    // 观察的数据源
    ([newDetail, newDictList, newHomeworkBuyCount, newHomeworkViewCount]) => {
      if (newDetail && newDetail.createTime) {
        formattedCreateDate.value = dayjs(newDetail.createTime).format('YYYY-MM-DD');
      }
      if (newDetail && newDetail.link) {
        //将link以||分割，分为一个数组
        links.value = newDetail.link.split(' || ');
      }
      if (newDetail && newDictList) {
        const dic = newDictList.find(item => Number(item.dictValue) === Number(newDetail.type));
        projectType.value = dic?.dictLabel;
      }
      if (newHomeworkViewCount) {
        //浏览量如果超过了万 显示为万
        if (newHomeworkViewCount > 10000) {
          formattedHomeworkViewCount.value = (newHomeworkViewCount / 10000).toFixed(2) + '万';
        } else {
          formattedHomeworkViewCount.value = newHomeworkViewCount.toString();
        }
      }
      if (newHomeworkBuyCount) {
        //浏览量如果超过了万 显示为万
        if (newHomeworkBuyCount > 10000) {
          formattedHomeworkBuyCount.value = (newHomeworkBuyCount / 10000).toFixed(2) + '万';
        } else {
          formattedHomeworkBuyCount.value = newHomeworkBuyCount.toString();
        }
      }
    }, {
      immediate: true
    });
    const packageChange = value => {
      packagePrice.value = priceList.value[value];
    };
    const getPackagePrice = async () => {
      //获取套餐价格信息
      const res = await XiaoniuFrontedControllerService.listUsingGet15();
      if (res.code == 200) {
        priceList.value.push(res.rows[0].otherPrice);
        priceList.value.push(res.rows[0].otherPrice1);
        priceList.value.push(res.rows[0].otherPrice2);
        packagePrice.value = priceList.value[0];
      }
    };
    onMounted(() => {
      getPackagePrice();
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 10,
          lg: 11,
          xl: 11,
          style: {
            "display": "flex",
            "justify-content": "center",
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
            src: getImageUrl(_ctx.projectDetail)
          }, null, 8, _hoisted_4)])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          sm: 24,
          md: 14,
          lg: 13,
          xl: 13
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("h1", null, _toDisplayString(_ctx.projectDetail.name), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_tag, {
            type: "primary",
            class: "el-tag-span"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ClockCircleOutlined), {
              class: "icon"
            }), _createTextVNode(" 发布" + _toDisplayString(formattedCreateDate.value), 1)]),
            _: 1
          }), _createVNode(_component_el_tag, {
            type: "success",
            class: "el-tag-span"
          }, {
            default: _withCtx(() => [_createVNode(_unref(EyeOutlined), {
              class: "icon"
            }), _createTextVNode(" 浏览" + _toDisplayString(formattedHomeworkViewCount.value) + "次 ", 1)]),
            _: 1
          }), _createVNode(_component_el_tag, {
            type: "warning",
            class: "el-tag-span"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ShoppingCartOutlined), {
              class: "icon"
            }), _createTextVNode(" 购买" + _toDisplayString(formattedHomeworkBuyCount.value) + "次 ", 1)]),
            _: 1
          })]), _hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (item, index) => {
            return _openBlock(), _createElementBlock("p", {
              key: index
            }, [_createTextVNode("视频或文章链接： "), _createVNode(_component_el_link, {
              href: item,
              type: "primary",
              target: "_blank"
            }, {
              default: _withCtx(() => [_createTextVNode("☛☛点我进入☚☚ ")]),
              _: 2
            }, 1032, ["href"])]);
          }), 128))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", null, "项目类型：" + _toDisplayString(projectType.value), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.projectDetail.price), 1)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_checkbox, {
            modelValue: agreementChecked.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => agreementChecked.value = $event)
          }, {
            default: _withCtx(() => [_createTextVNode("我已阅读并同意平台 ")]),
            _: 1
          }, 8, ["modelValue"]), _hoisted_17]), !isClickBuy.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            style: {
              "width": "100px"
            },
            type: "primary",
            size: "large",
            onClick: buy
          }, {
            default: _withCtx(() => [_createTextVNode("下单 ")]),
            _: 1
          })) : _createCommentVNode("", true), isClickBuy.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            style: {
              "width": "200px"
            },
            type: "primary",
            size: "large",
            disabled: ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(buyButtonText.value), 1)]),
            _: 1
          })) : _createCommentVNode("", true), !isClickBuy.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            style: {
              "width": "100px"
            },
            type: "warning",
            size: "large",
            onClick: redeem
          }, {
            default: _withCtx(() => [_createTextVNode("兑换 ")]),
            _: 1
          })) : _createCommentVNode("", true)])])]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", null, [_createVNode(_component_a_modal, {
        title: "兑换区",
        open: dialogVisibleRedeem.value,
        onOk: handleOk,
        onCancel: handleCancel
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          placeholder: "请输入兑换码",
          value: cdk.value,
          "onUpdate:value": _cache[1] || (_cache[1] = $event => cdk.value = $event)
        }, null, 8, ["value"])]),
        _: 1
      }, 8, ["open"])])]);
    };
  }
});